import React from 'react';
import AuthForm from './AuthForm';

const SignupForm = (props) => (
  <AuthForm {...props} initialMode="register" />
);

export default SignupForm;